<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <branch-offices-list :classOfDiv="cols" style="padding-top: 22px"
             v-on:triggerChange="branchOfficeSelected" dense
             :model="idBranchOfficeSelected"
             />
            <v-col>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details dense>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3" xl="2" sm="12">
              <v-tooltip bottom v-if="$utilFront.withPermission($prm.ADD_LOCATION)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" block v-bind="attrs" v-on="on" @click="changeAction(2)">
                    <v-icon left>mdi-plus</v-icon> Nueva localidad
                  </v-btn>
                </template>
                <span>Agregar localidad</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table :headers="headers"  :items="list" :search="search" :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
            no-data-text="Sin resultados disponibles" dense fixed-header height="auto">
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top v-if="$utilFront.withPermission($prm.UPDATE_LOCATION)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="getLocation(item)" :disabled="sending">
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </template>
                <span>Editar información</span>
              </v-tooltip>
              <span v-else>- - -</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <encabezado :elementos="encabezado" v-if="showAction(2) || showAction(3)" />
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black my-3">
                      Receptor de productividad
                    </h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <validation-provider v-slot="{ errors }" name="Nombre" rules="required|max:400">
                      <v-text-field v-model="localStaffModel.name" :maxlength="400" :counter="400"
                        :error-messages="errors" label="Nombre*" required autocomplete="off"></v-text-field>
                    </validation-provider>
                  </v-col>

                  <v-col>
                    <validation-provider v-slot="{ errors }" name="Primer apellido" rules="max:200|required|min:2">
                      <v-text-field v-model="localStaffModel.firstLastname" :maxlength="200" :counter="200"
                        :error-messages="errors" label="Primer apellido" required autocomplete="off"></v-text-field>
                    </validation-provider>
                  </v-col>

                  <v-col>
                    <validation-provider v-slot="{ errors }" name="Segundo apellido" rules="max:200|min:2">
                      <v-text-field v-model="localStaffModel.secondLastname" :maxlength="200" :counter="200"
                        :error-messages="errors" label="Segundo apellido" required autocomplete="off"></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <validation-provider v-slot="{ errors }" name="Puesto" rules="max:250">
                      <v-text-field v-model="localStaffModel.marketStall" :maxlength="250" :counter="250"
                        :error-messages="errors" label="Puesto" autocomplete="off"></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider v-slot="{ errors }" name="Número de contrato" rules="required|max:50">
                      <v-text-field v-model="localStaffModel.contractNumber" :maxlength="50" :counter="50"
                        :error-messages="errors" label="Número de contrato*" required autocomplete="off"></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <template  v-if="Array.isArray(cluesOptions) && cluesOptions.length">
                  <v-row>
                    <v-col>
                      <h3 class="font-weight-black my-3">CLUES</h3>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <validation-provider v-slot="{ errors }" name="CLUES" rules="required">
                        <v-autocomplete
                          v-model="model.idClue"
                          :items="cluesOptions"
                          item-text="label"
                          item-value="idClue"
                          label="Ingresa CLUES de la unidad*"
                          :error-messages="errors"
                          clearable
                          required
                          @change="onClueSelected"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                </template>
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black my-3">Ubicación</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="branchOffices.length > 1">
                    <validation-provider v-slot="{ errors }" name="Sucursal*" rules="required">
                      <v-autocomplete v-model="model.idBranchOffice" :items="branchOffices"
                        no-data-text="Sin resultados" label="Seleccione sucursal" append-icon="mdi-hospital-building"
                        :error-messages="errors" required clearable />
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider v-slot="{ errors }" name="Comunidad*" rules="required|max:200">
                      <v-text-field v-model="model.community" :maxlength="200" :counter="200" :error-messages="errors"
                        label="Comunidad" required autocomplete="off" :disabled="isClueLocked"></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider v-slot="{ errors }" name="Municipio*" rules="required|max:200">
                      <v-text-field v-model="model.municipality" :maxlength="200" :counter="200"
                        :error-messages="errors" label="Municipio" required autocomplete="off" :disabled="isClueLocked"></v-text-field>
                    </validation-provider>
                  </v-col>

                  <v-col>
                    <vc-date-picker color="green" v-model="date" is-range>
                      <template v-slot="{ inputEvents }">
                        <div class="flex justify-center items-center">
                          <validation-provider v-slot="{ errors }" name="Fecha estancia" rules="required|max:200">
                            <v-text-field v-on="inputEvents.start" :value="dateCompuded" label="Fecha estancia*"
                              :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'
      " @click:append="clearCalendar" :disabled-input="validData" :error-messages="errors">
                            </v-text-field>
                          </validation-provider>
                        </div>
                      </template>
                    </vc-date-picker>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="text-center">
              <v-col>
                <v-btn type="button" color="error" @click="changeAction(1)" plain>
                  <v-icon left>mdi-chevron-left</v-icon>
                  Volver
                </v-btn>
              </v-col>
              <v-col>
                <v-btn type="submit" :disabled="invalid || sending" color="primary">
                  Guardar <v-icon right>mdi-content-save</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
    </div>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "@/components/Sidebar";
import AutoLogout from "@/components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { UtilFront } from "@/core/";
import { LocationRequest } from "@/core/request";
import moment from "moment";
import BranchOfficesList from "../../components/BranchOfficesList.vue";

export default {
  name: "Localidad",
  components: {
    Loader,
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    AutoLogout,
    BranchOfficesList,
  },
  data() {
    return {
      sending: false,
      dialog: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      service: LocationRequest,
      search: "",
      headers: [
        { text: "Id localidad", value: "idLocation",align: "center" },
        { text: "Nombre", value: "name",align: "center" },
        { text: "Puesto", value: "marketStall",align: "center" },
        { text: "Número de contrato", value: "contractNumber",align: "center" },
        { text: "Comunidad", value: "community",align: "center" },
        { text: "Municipio", value: "municipality",align: "center" },
        { text: "Fecha de llegada", value: "arrivalDate",align: "center" },
        { text: "Fecha de salida", value: "departureDate",align: "center" },
        { text: "Acciones", value: "actions", sortable: false,align: "center" },
      ],
      encabezado: {
        icono: "mdi-map-marker",
        texto: "Localidad",
      },
      date: "",
      localStaffList: [],
      localStaffModel: {},
      clues: [],
      idBranchOfficeSelected: null,
      cols: "col-md-3 col-xl-3 col-sm-12",
      branchOffices: [],
      idClue: null,
      isClueLocked: false
    };
  },
  mounted() {
    this.listAll();
    this.getBranchOffices();
    this.loadCluesOptions();
  },
  computed: {
    dateCompuded() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return "";
      }

      return `${moment(this.date.start).format("DD/MM/YYYY")} al ${moment(
        this.date.end
      ).format("DD/MM/YYYY")}`;
    },
    validData() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return false;
      }
      return true;
    },
  },
  methods: {
    catchError: (e, x) => {
      UtilFront.errorhttp(e);
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.observer.reset();
        this.localStaffList = [];
        this.model = {};
        this.localStaffModel = {};
        this.action = action;
        this.date = "";
      } else {
        this.action = action;
      }
    },
    doAction() {
      if (this.$refs.observer.validate()) {
        switch (this.action) {
          case 2:
            this.add();
            break;
          case 3:
            this.update();
            break;
          default:
            break;
        }
      }
    },
    clearCalendar() {
      this.date = "";
    },
    add() {
      if (!this.sending) {
        this.sending = true;
        let receptor = {
          name: this.localStaffModel.name,
          firstLastname: this.localStaffModel.firstLastname,
          secondLastname: this.localStaffModel.secondLastname,
          marketStall: this.localStaffModel.marketStall,
          contractNumber: this.localStaffModel.contractNumber,
          type: 1,
        };
        this.localStaffList.push(receptor);

        this.model.arrivalDate = this.date.start;
        this.model.departureDate = this.date.end;
        this.model.branchOffice = {
          idBranchOffice:
            (this.model.idBranchOffice != null)
              ? this.model.idBranchOffice
              : this.$utilFront.getIdBranchOffice()
        };
        this.model.localStaffList = this.localStaffList;
        this.service
          .addLocation(this.model)
          .then((res) => {
            let { data, response, message } = res.data;
            if (response) {
              this.$utilFront.notifications(
                "Se ha registrado correctamente.",
                "SUCCESS"
              );
              this.changeAction(1);
              this.listAll();
            } else {
              message = message || "Ocurrió un error durante el registro.";
              this.$utilFront.notifications(message, "ERROR");
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      }
    },

    get() {
      this.sending = true;
      this.service
        .get({ idBranchOffice: this.$utilFront.getIdBranchOffice() })
        .then((res) => {
          let { data, response, message } = res.data;
          console.log("model", res.data)
          if (response) {
            this.model = data;
            
          } else {
            message = message || "Ocurrió un error al obtener la información.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    getLocation(item) {
      let data = {
        idLocation: item.idLocation,
      };
      this.service
        .getLocation(data)
        .then((res) => {
          let { data, status, code } = res.data;
          console.log('[getLocation] res.data:', res.data);
          if (code == 200 && status == "OK") {
            console.log('[getLocation] data.community:', data.community, 'data.municipality:', data.municipality);
            this.date = {
              start: new Date(data.arrivalDate),
              end: new Date(data.departureDate),
            };

            this.model = data;
            const lockFromBackend = (data.withClue === true) || (Number(data.idClue) !== 0);
            this.isClueLocked = lockFromBackend;
            this.localStaffModel = {
              idLocalStaff: data.localStaffList[0].idLocalStaff,
              contractNumber: data.localStaffList[0].contractNumber,
              name: data.localStaffList[0].name,
              firstLastname: data.localStaffList[0].firstLastname,
              secondLastname: data.localStaffList[0].secondLastname,
              marketStall: data.localStaffList[0].marketStall,
            };
          } else if (code == 401) {
            this.unauthorized();
          }
        })
        .catch(this.catchError)
        .finally(() => {
          //this.loader = false;
        });
      this.changeAction(3);
    },
    listAll() {
      let data = {
        branchOffice: {
          idBranchOffice:
            this.idBranchOfficeSelected != null
              ? this.idBranchOfficeSelected
              : this.$utilFront.getIdBranchOffice(),
        },
      };
      this.service.listAll(data).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((location) => {
            return {
              idLocation: location.idLocation,
              community: location.community,
              municipality: location.municipality,
              arrivalDate:
                location.arrivalDate != null
                  ? this.$utilFront.formatDate(location.arrivalDate)
                  : "--",
              departureDate:
                location.departureDate != null
                  ? this.$utilFront.formatDate(location.departureDate)
                  : "--",
              name: location.localStaffList[0]?.fullName,
              marketStall: location.localStaffList[0]?.marketStall,
              contractNumber: location.localStaffList[0]?.contractNumber,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    update() {
      if (!this.sending) {
        this.sending = true;
        this.localStaffList = [];
        let receptor = {
          idLocalStaff: this.localStaffModel.idLocalStaff,
          name: this.localStaffModel.name,
          firstLastname: this.localStaffModel.firstLastname,
          secondLastname: this.localStaffModel.secondLastname,
          marketStall: this.localStaffModel.marketStall,
          contractNumber: this.localStaffModel.contractNumber,
          type: 1,
        };
        this.localStaffList.push(receptor);

        this.model.arrivalDate = this.date.start;
        this.model.departureDate = this.date.end;
        this.model.branchOffice = { idBranchOffice: this.model.idBranchOffice };
        this.model.localStaffList = this.localStaffList;
        this.service
          .updateLocation(this.model)
          .then((res) => {
            let { data, response, message } = res.data;
            if (response) {
              this.$utilFront.notifications(
                "Se ha modificado correctamente.",
                "SUCCESS"
              );
              this.changeAction(1);
              this.listAll();
            } else {
              message = message || "Ocurrió un error durante la modificación.";
              this.$utilFront.notifications(message, "ERROR");
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      }
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAll();
    },
    getBranchOffices() {
      try {
        this.branchOffices = [];
        // this.branchOffices = this.$utilFront.getBranchOffices();
        this.branchOffices = this.$utilFront.getBranchOffices().map((it) => {
          return { text: it.branchOfficeName, value: it.idBranchOffice };
        });
      } catch (e) {
        console.error(e);
      }
    },
    loadCluesOptions () {
      const idBranchOffice = this.$utilFront.getIdBranchOffice();

      LocationRequest.getLocationByClues({ idBranchOffice })
        .then(({ data: resp }) => {
          const { code, status, data } = resp
          this.cluesOptions = (code === 200 && status === 'OK' && Array.isArray(data))
            ? data.map(it => ({
                ...it,
                label: `${it.clue} — ${it.unitName} (${it.municipality})`
              }))
            : []
        })
        .catch(err => {
          console.error('Error cargando CLUES:', err)
          this.cluesOptions = []
        })
    },
    onClueSelected(id) {
    if (id == null) { this.isClueLocked = false; return; }

    const selected = (this.cluesOptions || []).find(
      it => String(it.idClue) === String(id)
    );
    if (!selected) { this.isClueLocked = false; return; }

    const isSinClues = Number(selected.idClue) === 0 || String(selected.clue).toUpperCase() === 'SIN CLUES';

    if (isSinClues) {
      this.isClueLocked = false;
      this.model.community = '';
      this.model.municipality = '';
    } else {
      this.model.community = selected.unitName || '';
      this.model.municipality = selected.municipality || '';
      this.isClueLocked = true;
    }
  }
  },
};
</script>
